import React from 'react';

import { FormApi, FormState } from 'final-form';

import { usePermissiblePurposeReferencesListLazyQuery, VerifierType } from 'src/api';
import {
  VerifierAccountTypeFormFields,
  VerifierAccountTypeFormValues,
} from 'src/components/auth/SignupByInvitePageForm/types';

import { getPermissiblePurposeReferenceOption } from './utils';

export const useVerifierSignupPermissiblePurposeReferenceOptions = () => {
  const [
    getPermissiblePurposeReferencesList,
    { loading: permissiblePurposeReferencesLoading, data: permissiblePurposeReferencesData },
  ] = usePermissiblePurposeReferencesListLazyQuery();

  const prevVerifierType = React.useRef<VerifierType | null>(null);

  const onFormChange = React.useCallback(
    (
      formState: FormState<VerifierAccountTypeFormValues, Partial<VerifierAccountTypeFormValues>>,
      form: FormApi<VerifierAccountTypeFormValues, Partial<VerifierAccountTypeFormValues>>,
    ) => {
      const accountType = formState.values[VerifierAccountTypeFormFields.accountType];
      if (prevVerifierType.current !== accountType) {
        getPermissiblePurposeReferencesList({
          variables: {
            filter: {
              verifierType: {
                equals: accountType,
              },
            },
          },
        });
        form.change(VerifierAccountTypeFormFields.permissiblePurposeReferenceId, undefined);
      }
      prevVerifierType.current = accountType;
    },
    [getPermissiblePurposeReferencesList],
  );

  const permissiblePurposeReferencesOptionList = React.useMemo(() => {
    return (
      permissiblePurposeReferencesData?.permissiblePurposeReferenceList.map(
        getPermissiblePurposeReferenceOption,
      ) ?? []
    );
  }, [permissiblePurposeReferencesData?.permissiblePurposeReferenceList]);

  return {
    permissiblePurposeReferencesOptionList,
    permissiblePurposeReferencesLoading,
    onFormChange,
  };
};
